import './App.css';
import Main from './Components/header/Main';
function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
